import './style.css';
import { Type, Dom } from 'main.core';
import {
	resetCaptcha,
	AdaptiveCaptcha,
	CaptchaAnalytics,
	CaptchaScenarios,
	makeCaptchaParametersForComponent,
} from 'b24network.vue.adaptivecaptcha';

const CODE_LENGTH = 6;

export class PhoneConfirm extends BX.Network.Component
{
	constructor(parameters)
	{
		super(parameters);

		this.blockCache = {};
		this.timer = null;
		this.input = null;

		this.tmpValue = '';
		this.captchaErrorMessage = '';

		this.checkCountdown = this.checkCountdown.bind(this);
		this.handleChange = BX.defer(this.handleChange, this);
		this.callCheck = BX.debounce(this.callCheck, 300, this);
	}

	description(): Object
	{
		return {
			loader: {
				type: BX.Network.ComponentTransport,
				required: true,
			},
			phone: {
				type: String,
				required: true,
			},
			userId: {
				type: Number,
				required: true,
			},
			userSignature: {
				type: String,
				required: true,
			},
			dataSignature: {
				type: String,
				required: true,
			},
			dateSend: {
				type: Number,
			},
			adaptiveCaptcha: makeCaptchaParametersForComponent(),
			hasSmsSent: {
				type: Boolean,
				defaultValue: false,
			},
		};
	}

	components(): Object
	{
		return {
			ADAPTIVECAPTCHA: () => {
				return new BX.Network.VueAdapterComponent(
					AdaptiveCaptcha,
					{
						props: {
							settings: this.$data.adaptiveCaptcha.settings,
						},
						events: {
							captchaIsEnabledChange: (isEnabled) => {
								this.$data.adaptiveCaptcha.isEnabled = isEnabled;

								if (isEnabled)
								{
									this.#updateResendLinkDisableAttribute(true);
								}
							},
							captchaTypeChange: (newType) => {
								this.$data.adaptiveCaptcha.captchaType = newType;

								if (this.$data.adaptiveCaptcha.isEnabled)
								{
									CaptchaAnalytics.emitCaptchaShowEvent(
										this.$data.adaptiveCaptcha.captchaType,
										CaptchaScenarios.INVITE_SMS_RESEND,
									);
								}
							},
							captchaUserResultChange: (newUserResult) => {
								this.$data.adaptiveCaptcha.captchaUserResult = newUserResult;
								this.#updateResendLinkDisableAttribute(false);
							},
						},
					},
				);
			},
		};
	}

	onProcessData(data)
	{
		this.setDateSend(data.dateSend);
	}

	setDateSend(value)
	{
		this.$private.dateSend = Date.now() + value * 1000;
		this.$data.dateSend = value;

		return this;
	}

	localization()
	{
		return {
			B24NET_PHONECONFIRM_TITLE: BX.message('B24NET_PHONECONFIRM_TITLE'),
			B24NET_PHONECONFIRM_INPUT_TITLE: BX.message('B24NET_PHONECONFIRM_INPUT_TITLE'),
			B24NET_PHONECONFIRM_COUNTDOWN: BX.message('B24NET_PHONECONFIRM_COUNTDOWN'),
			B24NET_PHONECONFIRM_S: BX.message('B24NET_PHONECONFIRM_S'),
			B24NET_PHONECONFIRM_REPEAT: BX.message('B24NET_PHONECONFIRM_REPEAT'),
		};
	}

	render()
	{
		if (!this.blockCache.ROOT)
		{
			this.blockCache.ROOT = BX.create(
				'DIV',
				{
					events: {
						click: BX.delegateEvent(
							{
								attr: 'data-action',
							},
							BX.delegate(function() {
								this.routeAction(BX.proxy_context.getAttribute('data-action'), BX.proxy_context);
							}, this),
						),
					},
				},
			);
		}

		BX.adjust(this.blockCache.ROOT, {
			html: Mustache.render(
`
  <div class="b24-network-auth-form-block b24-network-auth-form-block-code">

	{{#hasSmsSent}}
		<div class="b24-network-auth-form-detail-block">
			<span class="b24-network-auth-form-detail">{{{title}}}</span>
		</div>
	{{/hasSmsSent}}

  	<div class="b24-network-auth-form-field-pass">
  		<div class="b24-network-auth-form-field-block">
  			<label class="b24-network-auth-form-field-label" for="code">{{message.B24NET_PHONECONFIRM_INPUT_TITLE}}</label>
  			<div class="b24-network-auth-form-field-input-block-code">
  				<div class="b24-network-auth-form-field-input-block">
  					<span data-node="INPUT"></span>
  					<svg class="b24-network-auth-form-loader-circular" viewBox="25 25 50 50" style="display: none;" data-node="LOADER">
  							<circle class="b24-network-auth-form-loader-path" cx="50" cy="50" r="20" fill="none" stroke-miterlimit="10"/>
  							<circle class="b24-network-auth-form-loader-path-inner" cx="50" cy="50" r="20" fill="none" stroke-miterlimit="10"/>
  						</svg>
  					<span class="b24-network-auth-form-field-error" style="display: none;" data-node="ERROR"></span>
  </div>
  			</div>
  		</div>
  	</div>
  	<div class="b24-network-auth-form-send-block">
		<div class="b24-network-auth-form-info" data-action="countdown" style="display: none;">
			{{{countdown}}}
		</div>

		<div data-component="ADAPTIVECAPTCHA" class="b24-network_captcha-wrapper"></div>

		{{#hasCaptchaError}}
		<div class="b24-network-auth-form-field-error b24-network_invite-email-captcha-error">
			{{captchaError}}
		</div>
		{{/hasCaptchaError}}

  		<div class="b24-network-auth-form-send b24net-sms-resend-link-wrapper" data-action="resend" style="display: block">
  			<span class="b24-network-auth-form-send-text" >{{message.B24NET_PHONECONFIRM_REPEAT}}</span>
  		</div>
  	</div>
  </div>
`,
{

	title: this.$localization.B24NET_PHONECONFIRM_TITLE.replace(
		'#PHONE#',
		Mustache.render(
			'<span class="b24-network-auth-form-bold">{{phone}}</span>',
			{ phone: this.$data.phone },
		),
	),
	countdown: this.$localization.B24NET_PHONECONFIRM_COUNTDOWN.replace(
		'#COUNTDOWN#',
		'<span class="b24-network-auth-form-focus" data-action="timer"></span>',
	),

	message: this.$localization,

	hasSmsSent: this.$data.hasSmsSent,
	hasCaptchaError: this.captchaErrorMessage !== '',
	captchaError: this.captchaErrorMessage,
},
			),
		});

		if (!this.blockCache.INPUT)
		{
			this.blockCache.INPUT = BX.create('INPUT', {
				props: {
					type: 'text',
					id: 'code',
					className: 'b24-network-auth-form-field-input',
				},
				attrs: {
					maxlength: '6',
				},
				events: {
					bxchange: this.handleChange,
				},
			});
		}

		this.blockCache.ERROR = this.blockCache.ROOT.querySelector('[data-node="ERROR"]');
		this.blockCache.LOADER = this.blockCache.ROOT.querySelector('[data-node="LOADER"]');

		this.blockCache.ROOT.querySelector('[data-node="INPUT"]').appendChild(this.blockCache.INPUT);

		this.checkCountdown();

		BX.defer(() =>
		{ BX.focus(this.blockCache.INPUT);
		})();

		this.bindComponents(this.blockCache.ROOT);

		return this.blockCache.ROOT;
	}

	#updateResendLinkDisableAttribute(isDisabled: boolean): void
	{
		const linkClass = 'b24net-sms-resend-link-wrapper';
		const disabledLinkClass = 'b24net-sms-resend-link-wrapper--disabled';
		const linkNode = document.querySelector(`.${linkClass}`);

		if (isDisabled)
		{
			Dom.addClass(linkNode, disabledLinkClass);
		}
		else
		{
			Dom.removeClass(linkNode, disabledLinkClass);
		}
	}

	routeAction(action)
	{
		switch (action)
		{
			case 'resend':
				this.resendCode();
				break;
		}
	}

	showError(errorList)
	{
		if (errorList.length > 0)
		{
			const errorMessage = errorList.filter((e) => (e.code !== 'ERROR_CAPTCHA'))
				.map((e) => e.message)
				.join('<br>')
			;

			if (errorMessage !== '')
			{
				this.blockCache.ERROR.innerHTML = errorMessage;
				this.blockCache.ERROR.style.display = 'inline';
				this.blockCache.INPUT.parentNode.classList.add('b24-network-auth-form-field-input-block-error');
			}
		}
	}

	hideError()
	{
		this.blockCache.INPUT.parentNode.classList.remove('b24-network-auth-form-field-input-block-error');
		this.blockCache.ERROR.style.display = 'none';
	}

	resendCode()
	{
		if (this.#isCountDownEnded())
		{
			if (this.$data.adaptiveCaptcha.isEnabled)
			{
				const hasCaptchaResult = Object.keys(this.$data.adaptiveCaptcha.captchaUserResult)
					.length > 0
				;

				if (!hasCaptchaResult)
				{
					return;
				}
			}

			this.blockCache.INPUT.value = '';
			this.hideError();
			this.$data.loader.query(
				'b24network.phoneauth.resendCode',
				{
					signedData: this.$data.dataSignature,
					...this.$data.adaptiveCaptcha.captchaUserResult,
				},
			).then(
				(result) => {
					this.$data.hasSmsSent = true;
					this.captchaErrorMessage = '';
					this.setDataSignature(result.data.DATA_SIGN)
						.setDateSend(result.data.DATE_SEND)
						.update()
						.checkCountdown();
				},
				(result) => {
					const captchaError = this.#getCaptchaError(result);

					if (captchaError === '')
					{
						this.showError(result.errors);
					}
					else
					{
						this.captchaErrorMessage = captchaError;
						this.update(true);
					}
				},
			);
			this.$data.adaptiveCaptcha.captchaUserResult = {};
		}
	}

	#getCaptchaError(errorResponse): String
	{
		return errorResponse?.errors
			.find((err) => err.code === 'ERROR_CAPTCHA')
			?.message ?? ''
		;
	}

	handleChange()
	{
		if (this.blockCache.INPUT.value.length === CODE_LENGTH)
		{
			this.callCheck();
		}
	}

	callCheck()
	{
		if (this.blockCache.INPUT.value.length === CODE_LENGTH)
		{
			this.check(this.blockCache.INPUT.value);
		}
	}

	showLoader()
	{
		this.blockCache.LOADER.style.display = 'block';
	}

	hideLoader()
	{
		this.blockCache.LOADER.style.display = 'none';
	}

	check(value)
	{
		if (value === this.tmpValue)
		{
			return;
		}

		this.hideError();
		this.tmpValue = value;

		this.showLoader();
		this.$data.loader.query(
			'b24network.phoneauth.confirm',
			{
				code: value,
				signedData: this.$data.userSignature,
			},
		).then(
			(result) => {
				this.hideLoader();
				this.callEvent('success', []);

				if (this.timer)
				{
					clearTimeout(this.timer);
					this.timer = null;
				}
			},
			(result) => {
				this.hideLoader();
				this.showError(result.errors);
			},
		);
	}

	checkCountdown(): Boolean
	{
		const root = this.blockCache.ROOT;

		if (this.#isCountDownEnded())
		{
			resetCaptcha(this.$data.adaptiveCaptcha.captchaType);
			root.querySelector('[data-component="ADAPTIVECAPTCHA"]').style.display = 'block';
			root.querySelector('[data-action="resend"]').style.display = 'block';
			root.querySelector('[data-action="countdown"]').style.display = 'none';
			this.#updateResendLinkDisableAttribute(true);

			return true;
		}

		root.querySelector('[data-component="ADAPTIVECAPTCHA"]').style.display = 'none';
		root.querySelector('[data-action="resend"]').style.display = 'none';
		root.querySelector('[data-action="countdown"]').style.display = 'block';
		root.querySelector('[data-action="timer"]').innerHTML = this.$localization
			.B24NET_PHONECONFIRM_S
			.replace('#LEFT#', this.#getRemainingCountDownSeconds())
		;

		if (this.timer)
		{
			clearTimeout(this.timer);
		}

		this.timer = setTimeout(this.checkCountdown, 500);

		return false;
	}

	#isCountDownEnded(): boolean
	{
		return this.#getRemainingCountDownSeconds() <= 0;
	}

	#getRemainingCountDownSeconds(): number
	{
		return Math.ceil((this.$private.dateSend - Date.now()) / 1000);
	}
}
